export const partnerDocumentsViewInitValue = {
  data: {
    certificateValueSharesDocuments: [],
    otherDocuments: [],
    sharesOwnershipDocuments: [],
    partnerId: '',
    partnerName: '',
    partner: null,
    isLoading: false,
  },
  actions: {
    handleUploadDocument: () => {},
    handleRemoveDocument: async () => {},
  },
};
